import React, { Component } from "react";
export class FileUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null
    };
    this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
  }
  handleFileUploadChange(event) {
    this.props.sendFileData(event.target.files[0]);
  }
  render() {
    return (
      <div className="upload-btn-wrapper dash-wrap">
        <button className="dash-file-btn">{this.props.text}</button>
        <input
          accept="application/pdf"
          onChange={this.handleFileUploadChange}
          type="file"
        />
      </div>
    );
  }
}

export default FileUploader;



// WEBPACK FOOTER //
// ./src/components/FileUploader.js